import { countDeadEnemyInhibitors } from '../domain/minionSpawner.js';

/**
 * syncSpawnerInhibitors — Mirror dead enemy inhibitor count onto live spawners (P3-12).
 */
export function syncSpawnerInhibitors(spawners, structures) {
  for (const spawner of spawners || []) {
    if (!spawner) continue;
    spawner.enemyInhibitorsDown = countDeadEnemyInhibitors(structures, spawner.team);
  }
}

/**
 * Prefer registry peers (includes dead). Fallback: allTurretEntities list.
 */
export function resolveStructurePeersForSpawners(context = {}) {
  if (context.entityRegistry) {
    return context.entityRegistry.getStructures();
  }
  return context.allTurretEntities || [];
}
